import { useEffect, useState } from "react";

// The SEO map (routes.js + seo_catalog.json + study/guide/blog data) is ~400 KB of source, so it loads as its own
// chunk. Crawlers already get the pre-rendered <head> from scripts/prerender.js; this only syncs the live DOM.
let seoModule = null;
let loading = null;
export const loadSeo = () => seoModule ? Promise.resolve(seoModule) : (loading ||= import("./routes").then((m) => (seoModule = m)));

export function useRouteSeo(pathname) {
  const [seo, setSeo] = useState(() => (seoModule ? seoModule.getSeoForPath(pathname) : null));
  useEffect(() => {
    let on = true;
    loadSeo().then((m) => { if (on) setSeo(m.getSeoForPath(pathname)); });
    return () => { on = false; };
  }, [pathname]);
  return seo;
}
